// extracted by mini-css-extract-plugin
export default {"headerNav":"MainNavigation_headerNav__fWZYN","schoolName":"MainNavigation_schoolName__AiHF9","Nav":"MainNavigation_Nav__B1QnS"};